// Migrated from app/assets/javascripts/orders/products_step.js
// Dependencies: jQuery (via jquery-global), translate (via locale.js)
// Handlebars templates inlined as JS functions

import jQuery from 'jquery'

// --- Template functions (replace Handlebars .slimbars templates) ---

function renderCashReceiptWidget(data) {
  var html = '<div class="card-body">'
  for (var i = 0; i < data.orderItems.length; i++) {
    var item = data.orderItems[i]
    html += '<div class="row small">'
    html += '<div class="col-2 text-right">' + item.amount + 'x</div>'
    html += '<div class="col-7 pl-0">' + item.name + '</div>'
    html += '<div class="col-3 pl-0 text-right">' + item.price + '</div>'
    html += '</div>'
  }
  if (data.discountApplied) {
    html += '<div class="row small mt-3">'
    html += '<div class="col-8">' + translate('korting') + '</div>'
    html += '<div class="col-4 text-right">' + data.discount + '</div>'
    html += '</div>'
  }
  html += '</div>'

  if (data.showHandlingCost) {
    html += '<div class="card-body bg-light small text-muted">'
    html += '<div class="row">'
    html += '<div class="col-8">' + translate('transactiekosten') + '</div>'
    html += '<div class="col-4 text-right">' + data.handlingCost + '</div>'
    html += '</div>'
    html += '</div>'
  }

  html += '<div class="card-body total">'
  html += '<div class="row">'
  html += '<div class="col-8">'
  if (data.showHandlingCost) {
    html += translate('subtotaal')
  } else {
    html += translate('totaal2')
  }
  html += '</div>'
  html += '<div class="col-4 text-right">' + data.total + '</div>'
  html += '</div>'
  html += '</div>'

  return html
}

function renderCashReceiptTotal(data) {
  return '<h2>' + data.total + '</h2>'
}

// --- serializeFormJSON jQuery plugin ---

jQuery.fn.serializeFormJSON = function () {
  var o = {}
  var a = this.serializeArray()
  jQuery.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]]
      }
      o[this.name].push(this.value || '')
    } else {
      o[this.name] = this.value || ''
    }
  })
  return o
}

// --- Number formatter ---

var formatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
})

function formatData(data) {
  var o = { orderItems: [], discountApplied: data.discount > 0, discount: 0, handlingCost: 0, total: 0, showHandlingCost: false }
  var index = 0
  var totalSumTickets = 0
  var amount
  var price
  var maxHandlingCost

  // order-items
  while (amount = data['order[order_items_attributes]['+index+'][amount]']) {
    amount = parseInt(amount)
    if (amount > 0) {
      price = parseFloat(data['order[order_items_attributes]['+index+'][price]'])
      var nrPhysicalTickets = parseInt(data['order[order_items_attributes]['+index+'][nr_physical_tickets]'])
      o.orderItems.push({
        amount: amount,
        name: data['order[order_items_attributes]['+index+'][description]'],
        price: formatter.format(amount*price)
      })
      totalSumTickets += (amount * nrPhysicalTickets)
      o.total += (amount * price)
    }
    index++
  }

  // calculate handling-cost
  if (o.total !== 0) {
    maxHandlingCost = parseFloat(data.maxHandlingCost)
    o.handlingCost = parseFloat(data.handlingCost) + (totalSumTickets * parseFloat(data.handlingCostPerTicket))
    if ((maxHandlingCost > 0) && (o.handlingCost > maxHandlingCost)) {
      o.handlingCost = maxHandlingCost
    }
    o.total += o.handlingCost
  }

  if (o.discountApplied) {
    o.discount = -1 * data.discount
    o.total += o.discount
  }
  o.showHandlingCost = o.handlingCost > 0
  o.discount = formatter.format(o.discount)
  o.handlingCost = formatter.format(o.handlingCost)
  o.total = formatter.format(o.total)

  return o
}

// --- Main initialization ---

jQuery(function() {

  $('.input-number-increment').click(function() {
    var $input = $(this).parents('.input-number-group').find('.input-number')
    var max = $input.attr('max')
    var val = parseInt($input.val(), 10)
    if (val < max) {
      $input.val(val + 1)
      $('form').trigger('change')
    }
  })

  $('.input-number-decrement').click(function() {
    var $input = $(this).parents('.input-number-group').find('.input-number')
    var val = parseInt($input.val(), 10)
    var min = $input.attr('min')
    if (val > min) {
      $input.val(val - 1)
      $('form').trigger('change')
    }
  })

  // Add active class for collapse element which is open by default
  $(".collapse.show").each(function(){
    $(this).prev(".card-header").addClass("active")
  })
  // Toggle active class on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function(){
    $(this).prev(".card-header").addClass("active")
  }).on('hide.bs.collapse', function(){
    $(this).prev(".card-header").removeClass("active")
  })

  $('form').change(function(e){
    e.preventDefault()
    var disabled = $(this).find(':input:disabled').removeAttr('disabled')
    var formData = formatData($(this).serializeFormJSON())
    disabled.attr('disabled','disabled')
    $('.cash-receipt').html(renderCashReceiptWidget( formData ))
    // only snowworld
    $('#total-amount').html(renderCashReceiptTotal( formData ))
  })

  // initialize cash receipt
  $('form').trigger('change')
})
